var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 355,
    viewBox: "0 0 305 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.187 246.301V383.741",
    stroke: "#2B195B",
    strokeWidth: 16,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.545 278.668H198.422C208.42 278.668 216.598 286.847 216.598 296.844C216.598 306.842 208.419 315.02 198.422 315.02H150.885C140.887 315.02 132.709 306.842 132.709 296.844C150.885 278.668 144.81 254.433 137.253 242.315L137.415 203.442C137.539 173.578 107.27 175.487 102.301 194.033L89.3642 242.315H-6.59668V387.727H184.79C194.787 387.727 202.966 379.547 202.966 369.55C202.966 359.552 194.787 351.374 184.79 351.374M189.334 315.02C199.331 315.02 207.51 323.2 207.51 333.196C207.51 343.192 199.331 351.374 189.333 351.374H155.986C145.989 351.374 137.81 343.193 137.81 333.196C137.81 323.199 145.988 315.02 155.986 315.02M189.334 278.668C199.331 278.668 207.51 270.488 207.51 260.492C207.51 250.494 199.32 242.315 189.335 242.315H141.342M161.088 387.727C151.092 387.727 142.913 379.547 142.913 369.55C142.913 359.552 151.092 351.374 161.088 351.374",
    stroke: "#2B195B",
    strokeWidth: 16,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2947 346.823V346.828",
    stroke: "#2B195B",
    strokeWidth: 16,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105 0L122.997 34.7156L161.575 41.1039L134.12 68.9477L139.966 107.612L105 90.1047L70.0352 107.612L75.8805 68.9477L48.425 41.1039L87.0032 34.7156L105 0Z",
    fill: "#2B195B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-14.3539 78.1664L4.87896 99.2281L33.2657 96.4461L19.1782 121.246L30.5961 147.383L2.6563 141.648L-18.6734 160.584L-21.8539 132.241L-46.4539 117.806L-20.4796 106.023L-14.3539 78.1664Z",
    fill: "#2B195B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.354 78.1664L205.121 99.2281L176.735 96.4461L190.822 121.246L179.405 147.383L207.344 141.648L228.673 160.584L231.854 132.241L256.454 117.806L230.48 106.023L224.354 78.1664Z",
    fill: "#2B195B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopup);
export default __webpack_public_path__ + "static/media/topup.18a1997cb7d37b829099cadb72927c49.svg";
export { ForwardRef as ReactComponent };